import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ResourceRequestEditableBlock from './ResourceRequestEditableBlock';
import ResourceRequestReadonlyBlock from './ResourceRequestReadonlyBlock';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    height: theme.spacing(3),
    userSelect: 'none'
  }
}));

export const ResourceRequestBlockGroupBlock = ({
  resourceRequest,
  chartStartDate,
  scale,
  isResourceRequestReadOnly,
  isEditSwitchEnabled,
  chartDisplayDateRange,
  isAllocationBlockPresent,
  canViewCostData,
  rowIndex,
  displayUnit,
  isPSAActualCornerCasesEnabled,
  isResourceActualModeEnabled
}) => {
  const classes = useStyles();

  return (
    <>
      {!isResourceRequestReadOnly && isEditSwitchEnabled ? (
        <ResourceRequestEditableBlock
          canViewCostData={canViewCostData}
          chartDisplayDateRange={chartDisplayDateRange}
          chartStartDate={chartStartDate}
          displayUnit={displayUnit}
          isAllocationBlockPresent={isAllocationBlockPresent}
          resourceRequest={resourceRequest}
          scale={scale}
          isPSAActualCornerCasesEnabled={isPSAActualCornerCasesEnabled}
          isResourceActualModeEnabled={isResourceActualModeEnabled}
        />
      ) : (
        <ResourceRequestReadonlyBlock
          scale={scale}
          rowIndex={rowIndex}
          resourceRequest={resourceRequest}
          chartStartDate={chartStartDate}
          classes={classes}
          canViewCostData={canViewCostData}
          chartDisplayDateRange={chartDisplayDateRange}
          isAllocationBlockPresent={isAllocationBlockPresent}
          displayUnit={displayUnit}
          isPSAActualCornerCasesEnabled={isPSAActualCornerCasesEnabled}
          isResourceActualModeEnabled={isResourceActualModeEnabled}
        />
      )}
    </>
  );
};

ResourceRequestBlockGroupBlock.propTypes = {
  scale: PropTypes.string.isRequired,
  chartStartDate: PropTypes.object.isRequired,
  resourceRequest: PropTypes.object.isRequired,
  canViewCostData: PropTypes.bool,
  isResourceRequestReadOnly: PropTypes.bool,
  chartDisplayDateRange: PropTypes.object.isRequired,
  displayUnit: PropTypes.string,
  isAllocationBlockPresent: PropTypes.bool,
  rowIndex: PropTypes.number.isRequired,
  isEditSwitchEnabled: PropTypes.bool,
  isPSAActualCornerCasesEnabled: PropTypes.bool,
  isResourceActualModeEnabled: PropTypes.bool
};

export default ResourceRequestBlockGroupBlock;
